import React, { Component } from 'react';

export default class Partners extends Component {
  render() {
    return (
      <section id="partners" style={{ textAlign: 'center' }}>
        <div className="row Partners">
          <div className="twelve columns">
            <h1>
              <span>Partners</span>
            </h1>
          </div>
        </div>

        <br></br>
        <div className="row">
           <div className="twelve columns">
             <div className="PartnerLogos">
               <img src="/images/aws_logo.png" alt="AWS Logo" style={{ height: '100px' }} />
               <img src="/images/comptia_logo.png" alt="CompTIA Logo" style={{ height: '100px' }} />
               <img src="/images/dell_logo.png" alt="Dell Logo" style={{ height: '100px' }} />
               <img src="/images/docker_logo.png" alt="Docker Logo" style={{ height: '100px' }} />
               <img src="/images/fly_logo.png" alt="Fly Logo" style={{ height: '100px' }} />
               <img src="/images/google_logo.png" alt="Google Logo" style={{ height: '100px' }} />
               <img src="/images/microsoft_logo.png" alt="Microsoft Logo" style={{ height: '100px' }} />
             </div>
           </div>
         </div>
      </section>
      // <section id="partners" style={{ textAlign: 'center' }}>
      //   <div className="row Partners">
      //     <div className="three columns header-col">
      //       <h1>
      //         <span>Partners</span>
      //       </h1>
      //     </div>
      //   </div>

      //   {/* <div className="row">
      //     <div className="twelve columns">
      //       <div className="PartnerLogos">
      //         <img src="/images/aws_logo.png" alt="AWS Logo" style={{ height: '100px' }} />
      //         <img src="/images/comptia_logo.png" alt="CompTIA Logo" style={{ height: '100px' }} />
      //         <img src="/images/dell_logo.png" alt="Dell Logo" style={{ height: '100px' }} />
      //         <img src="/images/docker_logo.png" alt="Docker Logo" style={{ height: '100px' }} />
      //         <img src="/images/fly_logo.png" alt="Fly Logo" style={{ height: '100px' }} />
      //         <img src="/images/google_logo.png" alt="Google Logo" style={{ height: '100px' }} />
      //         <img src="/images/microsoft_logo.png" alt="Microsoft Logo" style={{ height: '100px' }} />
      //       </div>
      //     </div>
      //   </div> */}
      // </section>
    );
  }
}
